/*
import dayjs from "dayjs";
import { useEffect, useState } from "react";

function McDateRangePicker({ value = [null, null], onChange }) {
  console.log("========== McDateRangePicker RENDER ==========");
  console.log("value reçu :", value);

  const [activeField, setActiveField] = useState("start");
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredDate, setHoveredDate] = useState(null);

  const [currentMonth, setCurrentMonth] = useState(
    value?.[0]
      ? value[0].toDate()
      : dayjs().add(3, "day").toDate()
  );

  const startDate = value?.[0] || null;
  const endDate = value?.[1] || null;

  // =========================================================
  // DEBUG STATE
  // =========================================================

  useEffect(() => {
    console.log("STATE isOpen :", isOpen);
  }, [isOpen]);

  useEffect(() => {
    console.log("STATE activeField :", activeField);
  }, [activeField]);

  useEffect(() => {
    console.log("STATE hoveredDate :", hoveredDate);
  }, [hoveredDate]);

  useEffect(() => {
    console.log("START DATE :", startDate);
    console.log("END DATE :", endDate);
  }, [startDate, endDate]);

  // =========================================================
  // FORMATAGE
  // =========================================================

  const formatDate = (date) => {
    if (!date) return "";

    return date.format("DD MMM YYYY");
  };

  // =========================================================
  // COMPARAISONS
  // =========================================================

  const isSameDay = (date1, date2) => {
    if (!date1 || !date2) {
      return false;
    }

    return date1.isSame(date2, "day");
  };

  const isBefore = (date1, date2) => {
    return date1.isBefore(date2, "day");
  };

  // =========================================================
  // OUVERTURE CALENDRIER
  // =========================================================

  const handleStartClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log("=================================");
    console.log("CLICK DATE DEBUT");
    console.log("=================================");

    console.log("Avant :", {
      activeField,
      isOpen,
    });

    setActiveField("start");
    setIsOpen(true);
    setHoveredDate(null);

    console.log("setIsOpen(true) exécuté");
  };

  const handleEndClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log("=================================");
    console.log("CLICK DATE FIN");
    console.log("=================================");

    console.log("Avant :", {
      activeField,
      isOpen,
    });

    setActiveField("end");
    setIsOpen(true);
    setHoveredDate(null);

    console.log("setIsOpen(true) exécuté");
  };

  // =========================================================
  // SELECTION DATE
  // =========================================================

  const handleDateSelect = (date) => {
    const selectedDate = dayjs(date);

    console.log("=================================");
    console.log("CLICK SUR UNE DATE");
    console.log("=================================");

    console.log("Date sélectionnée :", selectedDate.format("DD/MM/YYYY"));
    console.log("activeField :", activeField);
    console.log("startDate :", startDate?.format("DD/MM/YYYY"));
    console.log("endDate :", endDate?.format("DD/MM/YYYY"));

    // Première sélection
    if (activeField === "start") {
      console.log("ACTION : sélection du début");

      const newValue = [
        selectedDate,
        null,
      ];

      console.log("Nouveau value :", newValue);

      onChange(newValue);

      setActiveField("end");
      setHoveredDate(null);

      console.log("Passage en mode sélection de la date de fin");

      return;
    }

    // Sécurité
    if (!startDate) {
      console.log(
        "Aucun startDate trouvé → création d'un nouveau début"
      );

      onChange([
        selectedDate,
        null,
      ]);

      setActiveField("end");

      return;
    }

    // Date avant le début
    if (isBefore(selectedDate, startDate)) {
      console.log(
        "La date sélectionnée est avant le début → inversion"
      );

      onChange([
        selectedDate,
        startDate,
      ]);
    } else {
      console.log("ACTION : sélection de la date de fin");

      onChange([
        startDate,
        selectedDate,
      ]);
    }

    setHoveredDate(null);
    setIsOpen(false);

    console.log("Calendrier fermé");
  };

  // =========================================================
  // SURVOL
  // =========================================================

  const handleDateHover = (date) => {
    if (
      activeField !== "end" ||
      !startDate
    ) {
      return;
    }

    const hovered = dayjs(date);

    console.log(
      "HOVER DATE :",
      hovered.format("DD/MM/YYYY")
    );

    setHoveredDate(hovered);
  };

  // =========================================================
  // DATE PASSÉE
  // =========================================================

  const isPastDate = (date) => {
    return dayjs(date).isBefore(
      dayjs(),
      "day"
    );
  };

  // =========================================================
  // RANGE CONFIRMÉ
  // =========================================================

  const isInConfirmedRange = (date) => {
    if (!startDate || !endDate) {
      return false;
    }

    const current = dayjs(date);

    return (
      current.isAfter(startDate, "day") &&
      current.isBefore(endDate, "day")
    );
  };

  // =========================================================
  // RANGE PREVIEW
  // =========================================================

  const isInHoverRange = (date) => {
    if (
      !startDate ||
      !hoveredDate ||
      activeField !== "end"
    ) {
      return false;
    }

    const current = dayjs(date);

    // Hover avant la date de début
    if (
      hoveredDate.isBefore(
        startDate,
        "day"
      )
    ) {
      return (
        current.isAfter(
          hoveredDate,
          "day"
        ) &&
        current.isBefore(
          startDate,
          "day"
        )
      );
    }

    // Hover après la date de début
    return (
      current.isAfter(
        startDate,
        "day"
      ) &&
      current.isBefore(
        hoveredDate,
        "day"
      )
    );
  };

  // =========================================================
  // DATE DE FIN PREVIEW
  // =========================================================

  const isHoverEnd = (date) => {
    if (!hoveredDate) {
      return false;
    }

    return isSameDay(
      dayjs(date),
      hoveredDate
    );
  };

  // =========================================================
  // JOURS DU MOIS
  // =========================================================

  const getDaysInMonth = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();

    const firstDay = new Date(
      year,
      month,
      1
    );

    // JS :
    // dimanche = 0
    // lundi = 1
    //
    // Nous voulons :
    // lundi = 0
    // dimanche = 6

    let firstDayIndex =
      firstDay.getDay() - 1;

    if (firstDayIndex < 0) {
      firstDayIndex = 6;
    }

    const lastDay = new Date(
      year,
      month + 1,
      0
    );

    const days = [];

    // Cases vides
    for (
      let i = 0;
      i < firstDayIndex;
      i++
    ) {
      days.push(null);
    }

    // Jours du mois
    for (
      let day = 1;
      day <= lastDay.getDate();
      day++
    ) {
      days.push(
        new Date(
          year,
          month,
          day
        )
      );
    }

    return days;
  };

  // =========================================================
  // NAVIGATION MOIS
  // =========================================================

  const goToPreviousMonth = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log("MOIS PRÉCÉDENT");

    setCurrentMonth(
      new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth() - 1,
        1
      )
    );
  };

  const goToNextMonth = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log("MOIS SUIVANT");

    setCurrentMonth(
      new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth() + 1,
        1
      )
    );
  };

  // =========================================================
  // LABEL MOIS
  // =========================================================

  const monthLabel = dayjs(
    currentMonth
  ).format("MMMM YYYY");

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div className="mc-date-picker">

    

      <div className="mc-date-fields">


        <button
          type="button"
          className={`mc-date-field ${
            activeField === "start" && isOpen
              ? "is-active"
              : ""
          }`}
          onClick={handleStartClick}
        >
          <span className="mc-date-icon">
            <i className="bi bi-calendar-event" />
          </span>

          <span className="mc-date-field-content">

            <span className="mc-date-label">
              Date début
            </span>

            <span className="mc-date-value">
              {startDate
                ? formatDate(startDate)
                : "Choisir une date"}
            </span>

          </span>
        </button>

        <span className="mc-date-separator">
          →
        </span>

        <button
          type="button"
          className={`mc-date-field ${
            activeField === "end" && isOpen
              ? "is-active"
              : ""
          }`}
          onClick={handleEndClick}
        >
          <span className="mc-date-icon">
            <i className="bi bi-calendar-check" />
          </span>

          <span className="mc-date-field-content">

            <span className="mc-date-label">
              Date fin
            </span>

            <span className="mc-date-value">
              {endDate
                ? formatDate(endDate)
                : "Choisir une date"}
            </span>

          </span>
        </button>

      </div>


      {isOpen && (
        <div className="mc-calendar">


          <div className="mc-calendar-header">

            <button
              type="button"
              className="mc-calendar-nav"
              onClick={goToPreviousMonth}
            >
              <i className="bi bi-chevron-left" />
            </button>

            <div className="mc-calendar-month">
              {monthLabel}
            </div>

            <button
              type="button"
              className="mc-calendar-nav"
              onClick={goToNextMonth}
            >
              <i className="bi bi-chevron-right" />
            </button>

          </div>

          <div className="mc-calendar-weekdays">
            <span>L</span>
            <span>M</span>
            <span>M</span>
            <span>J</span>
            <span>V</span>
            <span>S</span>
            <span>D</span>
          </div>

          <div className="mc-calendar-days">

            {getDaysInMonth().map(
              (date, index) => {

                // Case vide

                if (!date) {
                  return (
                    <span
                      key={`empty-${index}`}
                      className="mc-calendar-empty"
                    />
                  );
                }

                const dateDayjs =
                  dayjs(date);

                const disabled =
                  isPastDate(date);

                const selectedStart =
                  isSameDay(
                    dateDayjs,
                    startDate
                  );

                const selectedEnd =
                  isSameDay(
                    dateDayjs,
                    endDate
                  );

                const confirmedRange =
                  isInConfirmedRange(date);

                const hoverRange =
                  isInHoverRange(date);

                const hoverEnd =
                  isHoverEnd(date);

                return (
                  <button
                    type="button"
                    key={date.toISOString()}
                    disabled={disabled}
                    onClick={() => {
                      console.log(
                        "CLICK JOUR :",
                        dateDayjs.format(
                          "DD/MM/YYYY"
                        )
                      );

                      handleDateSelect(date);
                    }}
                    onMouseEnter={() => {
                      handleDateHover(date);
                    }}
                    className={`
                      mc-calendar-day

                      ${
                        disabled
                          ? "is-disabled"
                          : ""
                      }

                      ${
                        selectedStart
                          ? "is-start"
                          : ""
                      }

                      ${
                        selectedEnd
                          ? "is-end"
                          : ""
                      }

                      ${
                        confirmedRange
                          ? "is-range"
                          : ""
                      }

                      ${
                        hoverRange
                          ? "is-hover-range"
                          : ""
                      }

                      ${
                        hoverEnd
                          ? "is-hover-end"
                          : ""
                      }
                    `}
                  >
                    {date.getDate()}
                  </button>
                );
              }
            )}

          </div>


          <div className="mc-calendar-footer">
            <span>
              {activeField === "start"
                ? "Choisissez votre date de départ"
                : "Choisissez votre date de retour"}
            </span>
          </div>

        </div>
      )}

    </div>
  );
}

export default McDateRangePicker;

*/

import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

function McDateRangePicker({ value = [null, null], onChange }) {
  console.log('========== McDateRangePicker RENDER ==========');
  console.log('value reçu :', value);

  const [activeField, setActiveField] = useState('start');
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredDate, setHoveredDate] = useState(null);

  const [currentMonth, setCurrentMonth] = useState(
    value?.[0] ? value[0].toDate() : dayjs().add(3, 'day').toDate()
  );

  const startDate = value?.[0] || null;
  const endDate = value?.[1] || null;

  // =========================================================
  // DEBUG STATE
  // =========================================================

  useEffect(() => {
    console.log('STATE isOpen :', isOpen);
  }, [isOpen]);

  useEffect(() => {
    console.log('STATE activeField :', activeField);
  }, [activeField]);

  useEffect(() => {
    console.log('STATE hoveredDate :', hoveredDate);
  }, [hoveredDate]);

  useEffect(() => {
    console.log('START DATE :', startDate);
    console.log('END DATE :', endDate);
  }, [startDate, endDate]);

  // =========================================================
  // FORMATAGE
  // =========================================================

  const formatDate = (date) => {
    if (!date) return '';

    return date.format('DD MMM YYYY');
  };

  // =========================================================
  // COMPARAISONS
  // =========================================================

  const isSameDay = (date1, date2) => {
    if (!date1 || !date2) {
      return false;
    }

    return date1.isSame(date2, 'day');
  };

  const isBefore = (date1, date2) => {
    return date1.isBefore(date2, 'day');
  };

  // =========================================================
  // OUVERTURE CALENDRIER
  // =========================================================

  const handleStartClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log('=================================');
    console.log('CLICK DATE DEBUT');
    console.log('=================================');

    console.log('Avant :', {
      activeField,
      isOpen,
    });

    setActiveField('start');
    setIsOpen(true);
    setHoveredDate(null);

    console.log('setIsOpen(true) exécuté');
  };

  const handleEndClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log('=================================');
    console.log('CLICK DATE FIN');
    console.log('=================================');

    console.log('Avant :', {
      activeField,
      isOpen,
    });

    setActiveField('end');
    setIsOpen(true);
    setHoveredDate(null);

    console.log('setIsOpen(true) exécuté');
  };

  // =========================================================
  // SELECTION DATE
  // =========================================================

  const handleDateSelect = (date) => {
    const selectedDate = dayjs(date);

    console.log('=================================');
    console.log('CLICK SUR UNE DATE');
    console.log('=================================');

    console.log('Date sélectionnée :', selectedDate.format('DD/MM/YYYY'));

    console.log('activeField :', activeField);
    console.log('startDate :', startDate?.format('DD/MM/YYYY'));
    console.log('endDate :', endDate?.format('DD/MM/YYYY'));

    // Première sélection
    if (activeField === 'start') {
      console.log('ACTION : sélection du début');

      const newValue = [selectedDate, null];

      console.log('Nouveau value :', newValue);

      onChange(newValue);

      setActiveField('end');
      setHoveredDate(null);

      console.log('Passage en mode sélection de la date de fin');

      return;
    }

    // Sécurité
    if (!startDate) {
      console.log("Aucun startDate trouvé → création d'un nouveau début");

      onChange([selectedDate, null]);

      setActiveField('end');

      return;
    }

    // Date avant le début
    if (isBefore(selectedDate, startDate)) {
      console.log('La date sélectionnée est avant le début → inversion');

      onChange([selectedDate, startDate]);
    } else {
      console.log('ACTION : sélection de la date de fin');

      onChange([startDate, selectedDate]);
    }

    setHoveredDate(null);
    setIsOpen(false);

    console.log('Calendrier fermé');
  };

  // =========================================================
  // SURVOL
  // =========================================================

  const handleDateHover = (date) => {
    if (activeField !== 'end' || !startDate) {
      return;
    }

    const hovered = dayjs(date);

    console.log('HOVER DATE :', hovered.format('DD/MM/YYYY'));

    setHoveredDate(hovered);
  };

  // =========================================================
  // DATE PASSEE
  // =========================================================

  const isPastDate = (date) => {
    return dayjs(date).isBefore(dayjs(), 'day');
  };

  // =========================================================
  // RANGE CONFIRME
  // =========================================================

  const isInConfirmedRange = (date) => {
    if (!startDate || !endDate) {
      return false;
    }

    const current = dayjs(date);

    return current.isAfter(startDate, 'day') && current.isBefore(endDate, 'day');
  };

  // =========================================================
  // RANGE PREVIEW
  // =========================================================

  const isInHoverRange = (date) => {
    if (!startDate || !hoveredDate || activeField !== 'end') {
      return false;
    }

    const current = dayjs(date);

    // Hover avant la date de début
    if (hoveredDate.isBefore(startDate, 'day')) {
      return current.isAfter(hoveredDate, 'day') && current.isBefore(startDate, 'day');
    }

    // Hover après la date de début
    return current.isAfter(startDate, 'day') && current.isBefore(hoveredDate, 'day');
  };

  // =========================================================
  // DATE DE FIN PREVIEW
  // =========================================================

  const isHoverEnd = (date) => {
    if (!hoveredDate) {
      return false;
    }

    return isSameDay(dayjs(date), hoveredDate);
  };

  // =========================================================
  // JOURS DU MOIS
  // =========================================================

  const getDaysForMonth = (monthDate) => {
    const year = monthDate.getFullYear();
    const month = monthDate.getMonth();

    const firstDay = new Date(year, month, 1);

    // JS :
    // dimanche = 0
    // lundi = 1
    //
    // Nous voulons :
    // lundi = 0
    // dimanche = 6
    let firstDayIndex = firstDay.getDay() - 1;

    if (firstDayIndex < 0) {
      firstDayIndex = 6;
    }

    const lastDay = new Date(year, month + 1, 0);

    const days = [];

    // Cases vides
    for (let i = 0; i < firstDayIndex; i++) {
      days.push(null);
    }

    // Jours du mois
    for (let day = 1; day <= lastDay.getDate(); day++) {
      days.push(new Date(year, month, day));
    }

    return days;
  };

  // =========================================================
  // NAVIGATION MOIS
  // =========================================================

  const goToPreviousMonth = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log('MOIS PRÉCÉDENT');

    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const goToNextMonth = (event) => {
    event.preventDefault();
    event.stopPropagation();

    console.log('MOIS SUIVANT');

    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  // =========================================================
  // DEUXIEME MOIS
  // =========================================================

  const nextMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);

  // =========================================================
  // LABELS MOIS
  // =========================================================

  const currentMonthLabel = dayjs(currentMonth).format('MMMM YYYY');

  const nextMonthLabel = dayjs(nextMonth).format('MMMM YYYY');

  // =========================================================
  // RENDU D'UN MOIS
  // =========================================================

  const renderMonth = (monthDate) => {
    return (
      <div className="mc-calendar-month-container">
        {/* JOURS DE LA SEMAINE */}

        <div className="mc-calendar-weekdays">
          <span>L</span>
          <span>M</span>
          <span>M</span>
          <span>J</span>
          <span>V</span>
          <span>S</span>
          <span>D</span>
        </div>

        {/* JOURS */}

        <div className="mc-calendar-days">
          {getDaysForMonth(monthDate).map((date, index) => {
            // Case vide
            if (!date) {
              return <span key={`empty-${index}`} className="mc-calendar-empty" />;
            }

            const dateDayjs = dayjs(date);

            const disabled = isPastDate(date);

            const selectedStart = isSameDay(dateDayjs, startDate);

            const selectedEnd = isSameDay(dateDayjs, endDate);

            const confirmedRange = isInConfirmedRange(date);

            const hoverRange = isInHoverRange(date);

            const hoverEnd = isHoverEnd(date);

            return (
              <button
                type="button"
                key={date.toISOString()}
                disabled={disabled}
                onClick={() => {
                  console.log('CLICK JOUR :', dateDayjs.format('DD/MM/YYYY'));

                  handleDateSelect(date);
                }}
                onMouseEnter={() => {
                  handleDateHover(date);
                }}
                className={`
                    mc-calendar-day
                    ${disabled ? 'is-disabled' : ''}
                    ${selectedStart ? 'is-start' : ''}
                    ${selectedEnd ? 'is-end' : ''}
                    ${confirmedRange ? 'is-range' : ''}
                    ${hoverRange ? 'is-hover-range' : ''}
                    ${hoverEnd ? 'is-hover-end' : ''}
                  `}
              >
                {date.getDate()}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div className="mc-date-picker">
      {/* ==========================
          CHAMPS DATE
      =========================== */}

      <div className="mc-date-fields">
        {/* DATE DEBUT */}

        <button
          type="button"
          className={`mc-date-field ${activeField === 'start' && isOpen ? 'is-active' : ''}`}
          onClick={handleStartClick}
        >
          <span className="mc-date-icon">
            <i className="bi bi-calendar-event" />
          </span>

          <span className="mc-date-field-content">
            <span className="mc-date-label">Date début</span>

            <span className="mc-date-value">
              {startDate ? formatDate(startDate) : 'Choisir une date'}
            </span>
          </span>
        </button>

        {/* SEPARATEUR */}

        <span className="mc-date-separator">→</span>

        {/* DATE FIN */}

        <button
          type="button"
          className={`mc-date-field ${activeField === 'end' && isOpen ? 'is-active' : ''}`}
          onClick={handleEndClick}
        >
          <span className="mc-date-icon">
            <i className="bi bi-calendar-check" />
          </span>

          <span className="mc-date-field-content">
            <span className="mc-date-label">Date fin</span>

            <span className="mc-date-value">
              {endDate ? formatDate(endDate) : 'Choisir une date'}
            </span>
          </span>
        </button>
      </div>

      {/* ==========================
          CALENDRIER
      =========================== */}

      {isOpen && (
        <div className="mc-calendar" style={{ width: '700px' }}>
          {/* HEADER */}

          <div className="mc-calendar-header">
            <button type="button" className="mc-calendar-nav" onClick={goToPreviousMonth}>
              <i className="bi bi-chevron-left" />
            </button>

            <div className="mc-calendar-months-header">
              <div className="mc-calendar-month">{currentMonthLabel}</div>

              <div className="mc-calendar-month">{nextMonthLabel}</div>
            </div>

            <button type="button" className="mc-calendar-nav" onClick={goToNextMonth}>
              <i className="bi bi-chevron-right" />
            </button>
          </div>

          {/* ==========================
              DEUX MOIS
          =========================== */}

          <div className="mc-calendar-months">
            {/* MOIS ACTUEL */}

            {renderMonth(currentMonth)}

            {/* MOIS SUIVANT */}

            {renderMonth(nextMonth)}
          </div>

          {/* FOOTER */}

          <div className="mc-calendar-footer">
            <span>
              {activeField === 'start'
                ? 'Choisissez votre date de départ'
                : 'Choisissez votre date de retour'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default McDateRangePicker;
